import * as React from "react";
import { TextArea as Area, useFieldState, FieldProps, useFieldApi, useField } from "informedv4";
import * as classNames from 'classnames';
import { inputClasses } from "../validation/ValidationClasses";


interface CustomTextAreaProps {
    field: string;
    inputAddon?: React.ReactNode;
    id?: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
    rows?: number;
    className?: string;
    maxLength?: number;
    [key: string]: any; // to allow additional props
}

export const TextArea = ({ field, inputAddon, id, name, className, maxLength, ...props }: CustomTextAreaProps) => {

    const { fieldApi, fieldState, ref, userProps } = useField({
        name: name,
        validate: props.validate,
        initialValue: props.initialValue,
        required: props.required,
    });

    const fieldName = field ?? name;
    if (!fieldName) {
        throw new Error("TextArea requires either `field` or `name`.");
    }

    const { error } = useFieldState(fieldName);

    const divClasses = inputAddon ? "input-group" : undefined;

    // Calculate character count
    const currentLength = (fieldState.value as string)?.length ?? 0;
    const isOverLimit = maxLength && currentLength > maxLength;

    return (
        <>
            <div className={divClasses}>
                <textarea
                    {...userProps}
                    id={id}
                    name={fieldName}
                    ref={ref}
                    value={fieldState.value as string ?? ''}
                    onChange={(e) => fieldApi.setValue(e.target.value)}
                    className={classNames(inputClasses(error as string), className)}
                    style={{ resize: 'vertical' }}
                    maxLength={maxLength}
                />
                {inputAddon ? <span className="input-group-addon">{inputAddon}</span> : null}
                {maxLength && (
                    <div className={classNames("help-block", { "text-danger": isOverLimit })}>
                        {currentLength} / {maxLength} characters
                    </div>
                )}
                {error ? (
                    <span data-automationid="ValidationError" className="field-validation-error area-field-validation-error">
                        {error as string}
                    </span>
                ) : null}
            </div>

        </>
    );
};
